Foundation.Mobile.Slideshow = function (links, open) {
    Foundation.Mobile.Slideshow.instances = Foundation.Mobile.Slideshow.instances || [];
    this.links = links;
    this.open = open;
    this.options = {
        backButtonHideEnabled:true,
        enableMouseWheel: false,
        enableKeyboard: false,
        captionAndToolbarShowEmptyCaptions: true,
        captionAndToolbarFlipPosition: true,
        imageScaleMethod: 'fitNoUpscale',
        captionAndToolbarAutoHideDelay: 0,
        getImageCaption: function (el) {
            var caption, title, credit;
            el = jQuery(el);
            var image = jQuery(el).find('img');

            caption = image.data('caption');
            credit = image.data('credit');
            title = image.data('title');

            // Return a DOM element with custom styling
            var captionEl = jQuery('<div/>');

            if ( typeof title != "undefined" && title != "") {
                captionEl.append(jQuery('<span/>').html(title).addClass('ev-title'));
            }

            if ( typeof caption != "undefined" && caption != "") {
                captionEl.append(jQuery('<span/>').html(caption).addClass('ev-caption'));
            }

            if ( typeof credit != "undefined" && credit != "") {
                captionEl.append(jQuery('<span/>').html(credit).addClass('ev-credit'));
            }
            if ( captionEl.html() != "") {
                return captionEl;
            }
            else {
                return null;
            }
        }
    }
    this.init();
    return true;
};


Foundation.Mobile.Slideshow.prototype.init = function () {
        this.instance = jQuery(this.links).photoSwipe(this.options);

        Foundation.Mobile.Slideshow.instances.push(this.instance);
        var refresh = function () {
            if (typeof this.myScroll != "undefined") {
                setTimeout(this.myScroll.refresh.bind(this.myScroll), 0);
            }
        }

        this.instance.addEventHandler(window.Code.PhotoSwipe.EventTypes.onToolbarTap, refresh.bind(this) );

        this.instance.addEventHandler(window.Code.PhotoSwipe.EventTypes.onBeforeShow, function () {
            jQuery(document).on('click touch', '.ps-caption', this.captionToggle.bind(this));
        }.bind(this) );

        this.instance.addEventHandler(window.Code.PhotoSwipe.EventTypes.onHide, function () {
            jQuery(document).off('click touch', '.ps-caption');
        }.bind(this) );

        jQuery(this.open).on('click', function () {
            this.instance.show(0);
        }.bind(this));
}

Foundation.Mobile.Slideshow.prototype.captionToggle = function (e) {
    var el = e.currentTarget;
    if (jQuery(el).hasClass('long-caption')) {
        jQuery(el).removeClass('long-caption');
        // make the slideshow container resize to get rid of scroll
        // bars
        setTimeout(this.instance.toolbar.resetPosition.bind(this.instance.toolbar), 0);
        if ( typeof iScroll != "undefined") {
            setTimeout(function () {
                if ( typeof this.myScroll != "undefined") {
                    this.myScroll.destroy();
                }
            }.bind(this), 40);
            jQuery('.ps-caption').height('auto');
        }
    }
    else {
        jQuery(el).addClass('long-caption');
        if ( typeof iScroll != "undefined") {
            jQuery('.ps-caption').height(jQuery('.ps-uilayer').height() - 46);
            this.myScroll = new iScroll(jQuery('.ps-caption')[0]);
        }
    }
}

window["Foundation"]["Mobile"]["Slideshow"] = Foundation.Mobile.Slideshow;

/* eslint eqeqeq: "off" */
